import { z } from "zod";

export const updateWalkieTalkiePreferencesSchema = z
	.object({
		walkie_talkie_enabled: z.boolean(),
	})
	.strict();

export type UpdateWalkieTalkiePreferencesPayload = z.infer<typeof updateWalkieTalkiePreferencesSchema>;
